<template>
  <b-modal title=""
           :modelValue="item !== null"

           footer-class="border-top-0 d-flex justify-content-between"
           @update:modelValue="$event === false && (item = null)">
    <template #default>
      <div class="row">
        <div class="col-sm-12">
          <FormInputWrapper v-slot="parentProps" field="isAgreeBlacklistPaymentMethod" form="requisitesForm">
            <div class="alert alert-danger mb-0" :class="parentProps.class" role="alert">
              <div class="form-check small mb-0">
                <input class="form-check-input" v-model="form.isAgreeBlacklistPaymentMethod" type="checkbox" value="" id="isAgreeBlacklistPaymentMethod">
                <label class="form-check-label" for="isAgreeBlacklistPaymentMethod">
                  {{ helper.trans('labels.agree_with_risk')}}
                </label>
              </div>
            </div>
          </FormInputWrapper>
        </div>
      </div>
    </template>

    <template #footer>
      <button type="button" @click="item = null" class="btn btn-outline-dark btn-sm text-capitalize-first">
        {{ helper.trans('button.cancel')  }}
      </button>
      <LoaderWrapper ref="loader" :zoom="0.5">
        <button type="button" @click="onOkClick()" class="btn btn-outline-danger btn-sm text-capitalize-first">
          {{ helper.trans('button.ok') }}
        </button>
      </LoaderWrapper>

    </template>
  </b-modal>
</template>

<script lang="ts">

import {defineComponent, ref, watch} from 'vue'
import {reactive, toRefs} from "@vue/reactivity";
import {BModal} from "bootstrap-vue-3";
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {helper} from "@/service/CommonHelper";
import TraderRequisitesDTO from "@/models/TraderRequisitesDTO";
import {api} from "@/service/APIClient";
import FormInputWrapper from "@/components/FormInputWrapper.vue";


export default defineComponent({
  components: {
    BModal,
    LoaderWrapper,
    FormInputWrapper
  },
  emits: ['state:updated'],
  setup(props, {emit}) {
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)

    const state = reactive({
      form: {
        isAgreeBlacklistPaymentMethod: false
      } as any,
      item: null as TraderRequisitesDTO|null
    });

    const show = (item: TraderRequisitesDTO) => {
      helper.clearErrors('requisitesForm')
      state.form = {
        isAgreeBlacklistPaymentMethod: false
      }
      state.item = item
    }

    const onOkClick = async () => {
      if (!state.item) {
        return;
      }

      helper.clearErrors('requisitesForm')

      loader.value?.show()
      try {
        const req = await api.toggleRequisitesActivity(state.item.id, 'enable', state.form)
        state.item.isActive = req.isActive;
        emit('state:updated', {id: state.item.id, isActive: state.item.isActive})
      } catch (e) {
        helper.handleErrors('requisitesForm', e)
        state.item.isActive = false;
        emit('state:updated', {id: state.item.id, isActive: state.item.isActive})
        return;
      } finally {
        loader.value?.hide()
      }


      state.item = null;
    }

    watch(() => state.item, async (value, oldValue) => {
      if (!value && oldValue) {
        emit('state:updated', {id: oldValue?.id, isActive: oldValue?.isActive})
      }
    })
    return {
      ...toRefs(state),
      onOkClick,
      show,
      loader,
      helper
    }
  }
})
</script>
